import { PresetPictureSet, PresetPictureSetOptions } from '../../../shared/performance/pictures';

// Bricks-next breakpoints: SM (375px), MD (768px), LG (1201px), XL (1400px)
const BREAKPOINTS = {
  SM: 375,
  MD: 768,
  LG: 1201,
  XL: 1400,
} as const;

const HERO_DESKTOP_IMAGE_SIZES: PresetPictureSet = [
  {
    minWidth: BREAKPOINTS.LG,
    maxWidth: BREAKPOINTS.XL,
    preset: 'square-512',
  },
  {
    minWidth: BREAKPOINTS.XL,
    maxWidth: null,
    preset: 'square-1024',
  },
];

const HERO_MOBILE_IMAGE_SIZES: PresetPictureSet = [
  {
    minWidth: BREAKPOINTS.SM,
    maxWidth: BREAKPOINTS.MD,
    preset: 'square-256',
  },
  {
    minWidth: BREAKPOINTS.MD,
    maxWidth: BREAKPOINTS.LG,
    preset: 'square-512',
  },
];

export const HERO_IMAGE_DESKTOP_PROPS: Omit<PresetPictureSetOptions, 'photoUrl'> = {
  sizes: HERO_DESKTOP_IMAGE_SIZES,
  debugImageSizes: false,
  lazy: false,
  preload: true,
  fetchPriority: 'high',
  radii: {
    borderTopStartRadius: 'none',
    borderBottomStartRadius: 'none',
    borderTopEndRadius: 'none',
    borderBottomEndRadius: 'none',
  },
};

export const HERO_IMAGE_MOBILE_PROPS: Omit<PresetPictureSetOptions, 'photoUrl'> = {
  sizes: HERO_MOBILE_IMAGE_SIZES,
  debugImageSizes: false,
  lazy: false,
  preload: true,
  fetchPriority: 'high',
  radii: {
    borderTopStartRadius: 'none',
    borderBottomStartRadius: 'none',
    borderTopEndRadius: 'none',
    borderBottomEndRadius: 'none',
  },
};
